import { Component } from "react"

export default class extends Component {

    constructor(props, context) {
        super(props, context);

        this.getRainfallFillPercentage = this.getRainfallFillPercentage.bind(this);
    }

    getRainfallFillPercentage(min, max, val) {
        let range = max - min;
        let startValue = val - min;
        let rainfallPercentage = (( startValue / range ) * 100);

        let barHeight = 60;
        let output = barHeight - (( rainfallPercentage * barHeight ) / 100);

        return (output );
    }

    render(){
        const { rainfallPast1hrRainfallScaleMin,
                rainfallPast1hrRainfallScaleMax,
                rainfallPast1hrRainfallScaleVal,
                rainfallPast24hrRainfallScaleMin,
                rainfallPast24hrRainfallScaleMax,
                rainfallPast24hrRainfallScaleVal,
                rainfallThisMonthURL,
                rainfallLastMonthURL} = this.props;

        return(
            <div>
                <div className="chart-left text-left">
                    <div className="rainfall-chart">
                        <div className="mb-1 chart-title">Last 1 hr</div>
                        <svg width="100%" height="64" viewBox="0 0 76 64">
                            <defs>
                                <mask id="rainfallMask1" x="0" y="0">
                                    <rect x="1" y="2" width="30" height="60" style={{fill: "#fff", stroke: "transparent", strokeWidth: 1 }}/>
                                </mask>
                            </defs>
                            <rect x="0" y="1" width="32" height="62" style={{ fill: "#c1c2c3" }}/>
                            <rect x="1" y="2" width="30" height="60" style={{ fill: "#f1f2f3" }}/>
                            <rect x="0" y={this.getRainfallFillPercentage(rainfallPast1hrRainfallScaleMin, rainfallPast1hrRainfallScaleMax, rainfallPast1hrRainfallScaleVal)}
                                  width="32" height="104" style={{ mask: "url(#rainfallMask1)", fill: "#1778ce", stroke: "#125da0", strokeWidth: 1, transition: "all 200ms" }}/>
                            <text className="chart-label" x="35" y="10">{rainfallPast1hrRainfallScaleMax}</text>
                            <text className="chart-label" x="35" y="61">{rainfallPast1hrRainfallScaleMin}</text>
                        </svg>
                        <div className="chart-value is-small">{ (rainfallPast1hrRainfallScaleVal === null) ? "--" : rainfallPast1hrRainfallScaleVal } <span title="millimetres">mm</span></div>
                    </div>
                </div>

                <div className="chart-right text-left">
                    <div className="rainfall-chart">
                        <div className="mb-1 chart-title">Last 24 hr</div>
                        <svg width="100%" height="64" viewBox="0 0 76 64">
                            <defs>
                                <mask id="rainfallMask2" x="0" y="0">
                                    <rect x="1" y="2" width="30" height="60" style={{fill: "#fff", stroke: "transparent", strokeWidth: 1 }}/>
                                </mask>
                            </defs>
                            <rect x="0" y="1" width="32" height="62" style={{ fill: "#c1c2c3" }}/>
                            <rect x="1" y="2" width="30" height="60" style={{ fill: "#f1f2f3" }}/>
                            <rect x="0" y={this.getRainfallFillPercentage(rainfallPast24hrRainfallScaleMin, rainfallPast24hrRainfallScaleMax, rainfallPast24hrRainfallScaleVal)}
                                  width="32" height="104" style={{ mask: "url(#rainfallMask2)", fill: "#1778ce", stroke: "#125da0", strokeWidth: 1, transition: "all 200ms" }}/>
                            <text className="chart-label" x="35" y="10">{rainfallPast24hrRainfallScaleMax}</text>
                            <text className="chart-label" x="35" y="61">{rainfallPast24hrRainfallScaleMin}</text>
                        </svg>
                        <div className="chart-value is-small">{ (rainfallPast24hrRainfallScaleVal === null) ? "--" : rainfallPast24hrRainfallScaleVal } <span title="millimetres">mm</span></div>
                    </div>
                </div>

                <h3 className="mb-0 mt-2 view-rainfall-heading">View Rainfall Summary</h3>
                <a className="link" href={rainfallThisMonthURL} target="_blank">This Month</a> | <a className="link" href={rainfallLastMonthURL} target="_blank">Last
                    Month</a>
            </div>

        )
    }
}




// WEBPACK FOOTER //
// ./src/components/site/rainfall/rainfall-component.js